//export const REACT_APP_API_BASE_URL= 'http://localhost:49882/api/'

export const REACT_APP_API_BASE_URL='https://api.varthagam.in/api/'